export const PRODUCT_IMAGE_PLACEHOLDER_URL = '/assets/sem-foto.png'

const PLACEHOLDER_IMAGE_TEXTS = new Set([
  'foto',
  'sem foto',
  'sem imagem',
  'no photo',
  'no image',
  'nophoto',
  'noimage',
  'placeholder',
])

const PLACEHOLDER_IMAGE_URL_PATTERN = /(?:^|[/?#&=._-])(?:sem[-_\s]?(?:foto|imagem)|foto[-_\s]?indisponivel|imagem[-_\s]?indisponivel|no[-_\s]?(?:photo|image)|nophoto|noimage|placeholder|default[-_\s]?(?:product|produto|image|foto)|produto[-_\s]?sem[-_\s]?foto)(?=$|[/?#&=._-])/i
const LEGACY_MID_IMAGE_URL_PATTERN = /_mid(?=[.#?]|$)/i
const PUBLIC_MEDIA_MID_IMAGE_URL_PATTERN = /(\/(?:c2s_brasiltec|c2s_source)\/midia\/\d+\/\d+\/)mid\.png(?=[?#]|$)/i

function decodeImageUrl(value: string): string {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

export function normalizeProductImageUrl(value: string | null | undefined): string {
  if (typeof value !== 'string') return ''

  const trimmed = value.trim()
  if (!trimmed) return ''

  const normalized = decodeImageUrl(trimmed).trim().toLocaleLowerCase('pt-BR')
  if (PLACEHOLDER_IMAGE_TEXTS.has(normalized)) return ''
  if (normalized.includes('placehold.co/')) return ''
  if (PLACEHOLDER_IMAGE_URL_PATTERN.test(normalized)) return ''

  return trimmed
}

export function isMidProductImageUrl(value: string | null | undefined): boolean {
  const normalized = normalizeProductImageUrl(value)
  if (!normalized) return false

  return LEGACY_MID_IMAGE_URL_PATTERN.test(normalized)
    || PUBLIC_MEDIA_MID_IMAGE_URL_PATTERN.test(normalized)
}

export function promoteProductImageUrlToHigh(value: string | null | undefined): string {
  const normalized = normalizeProductImageUrl(value)
  if (!normalized) return ''

  return normalized
    .replace(PUBLIC_MEDIA_MID_IMAGE_URL_PATTERN, '$1high.png')
    .replace(LEGACY_MID_IMAGE_URL_PATTERN, '')
}

export function normalizeProductImageList(
  values: Array<string | null | undefined>,
): string[] {
  return Array.from(new Set(values.map((value) => normalizeProductImageUrl(value)).filter(Boolean)))
}

export function withProductImagePlaceholder(
  values: Array<string | null | undefined>,
  options: { includePlaceholder?: boolean } = {},
): string[] {
  const images = normalizeProductImageList(values)
  return images.length > 0 || options.includePlaceholder === false
    ? images
    : [PRODUCT_IMAGE_PLACEHOLDER_URL]
}

export function resolveProductImageUrl(
  value: string | null | undefined,
  options: { includePlaceholder?: boolean } = {},
): string {
  return normalizeProductImageUrl(value)
    || (options.includePlaceholder === false ? '' : PRODUCT_IMAGE_PLACEHOLDER_URL)
}
